import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StyledButton from "@/components/StyledHtmlElements/Button";

const Datenschutzerklaerung = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex justify-center items-center h-full bg-gray-100 mt-4 mb-4">
      <div className="text-xs md:text-xs bg-white p-8 rounded shadow-md w-full max-w-7xl text-left">
        <h2 className="text-lg md:text-2xl font-bold mb-6">
          Datenschutzerklärung
        </h2>
        <h3 className="text-sm md:text-xl font-semibold mb-4">1. Einleitung</h3>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns sehr wichtig. Diese
          Datenschutzerklärung informiert Sie über die Art, den Umfang und den
          Zweck der Erhebung und Verwendung personenbezogener Daten auf unserer
          Webseite. Wir verarbeiten Ihre Daten gemäß der Europäischen
          Datenschutz-Grundverordnung (DSGVO).
        </p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          2. Verantwortliche Stelle
        </h3>
        <p>
          Verantwortlich für die Verarbeitung personenbezogener Daten auf dieser
          Webseite ist:
        </p>
        <p>Icehawkai UG (haftungsbeschränkt) i.G</p>
        <p>Carsten Pauli</p>
        <p>Bagelstraße 107, 40479 Düsseldorf</p>
        <p>pauli@icehawkai.de</p>
        <p>+49 (0)211 97179205</p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          3. Erhobene Daten und Verarbeitungszwecke
        </h3>
        <h4 className="text-sm md:text-xl font-semibold mb-2">
          3.1 Daten zur Nutzung der Webseite
        </h4>
        <p>
          Bei jedem Zugriff auf unsere Webseite werden automatisch Daten
          erfasst, die Ihr Browser an unseren Server übermittelt. Dies können
          folgende Daten sein:
        </p>
        <ul className="list-disc list-inside">
          <li>IP-Adresse</li>
          <li>Datum und Uhrzeit des Zugriffs</li>
          <li>Besuchte Seiten</li>
          <li>Verwendeter Browser und Betriebssystem</li>
          <li>Referrer-URL (die zuvor besuchte Seite)</li>
        </ul>
        <p>
          Diese Daten werden zur Sicherstellung eines reibungslosen
          Verbindungsaufbaus und zur Verbesserung unserer Webseite verwendet.
          Eine Zusammenführung dieser Daten mit anderen Datenquellen erfolgt
          nicht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes
          Interesse an der Optimierung der Webseite).
        </p>

        <h4 className="text-sm md:text-xl font-semibold mt-4 mb-2">
          3.2 Datenverarbeitung bei Kontaktaufnahme
        </h4>
        <p>
          Wenn Sie uns per E-Mail oder über ein Kontaktformular ansprechen,
          verarbeiten wir die von Ihnen bereitgestellten Daten (z. B. Name,
          E-Mail-Adresse, Telefonnummer) zur Bearbeitung Ihrer Anfrage.
          Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b DSGVO (Erfüllung
          eines Vertrages oder vorvertragliche Maßnahmen).
        </p>

        <h4 className="text-sm md:text-xl font-semibold mt-4 mb-2">
          3.3 Datenanalyse und Leistungsbewertung
        </h4>
        <p>
          Zur Analyse der Spielerperformance werden Daten wie Spielstatistiken,
          Trainingsdaten, physische Leistungsdaten und Videoanalysen
          verarbeitet. Diese Daten stammen entweder direkt vom Nutzer oder aus
          externen Datenquellen (z. B. Analyse-Dienste, externe Datenbanken).
          Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse) sowie gegebenenfalls Art. 6 Abs. 1 lit. a
          DSGVO (Einwilligung).
        </p>

        <h4 className="text-sm md:text-xl font-semibold mt-4 mb-2">
          3.4 Scouting und Talentrekrutierung
        </h4>
        <p>
          Wir verarbeiten Daten von Spielerprofilen aus verschiedenen Quellen,
          um Talente zu identifizieren und Leistungsmetriken zu bewerten. Die
          Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
          f DSGVO (berechtigtes Interesse).
        </p>

        <h4 className="text-sm md:text-xl font-semibold mt-4 mb-2">
          3.5 Verletzungsprävention und Risikobewertung
        </h4>
        <p>
          Zur Verletzungsprävention verarbeiten wir physische Leistungsdaten und
          Trainingsdaten der Spieler. Diese Daten werden zur Einschätzung des
          Verletzungsrisikos verwendet. Rechtsgrundlage hierfür ist Art. 6 Abs.
          1 lit. f DSGVO.
        </p>

        <h4 className="text-sm md:text-xl font-semibold mt-4 mb-2">
          3.6 Cookies und ähnliche Technologien
        </h4>
        <p>
          Unsere Webseite verwendet Cookies und ähnliche Technologien, um die
          Benutzererfahrung zu verbessern und statistische Analysen
          durchzuführen. Rechtsgrundlage hierfür ist Ihre Einwilligung gemäß
          Art. 6 Abs. 1 lit. a DSGVO. Sie können die Verwendung von Cookies in
          den Einstellungen Ihres Browsers deaktivieren.
        </p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          4. Datenweitergabe an Dritte
        </h3>
        <p>
          Eine Weitergabe Ihrer personenbezogenen Daten an Dritte erfolgt nur,
          wenn:
        </p>
        <ul className="list-disc list-inside">
          <li>
            dies zur Vertragserfüllung erforderlich ist (Art. 6 Abs. 1 lit. b
            DSGVO),
          </li>
          <li>Sie eingewilligt haben (Art. 6 Abs. 1 lit. a DSGVO),</li>
          <li>
            wir einer rechtlichen Verpflichtung unterliegen (Art. 6 Abs. 1 lit.
            c DSGVO), oder
          </li>
          <li>
            es zur Wahrung berechtigter Interessen erforderlich ist (Art. 6 Abs.
            1 lit. f DSGVO).
          </li>
        </ul>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          5. Datenverarbeitung durch Drittanbieter
        </h3>
        <p>
          Für bestimmte Funktionen unserer Webseite nutzen wir Dienste von
          Drittanbietern (z. B. Cloud-Dienste von AWS, Analyse-Tools). Diese
          Anbieter können in Drittländern ansässig sein, insbesondere in den
          USA. Eine Datenübermittlung in Drittländer erfolgt nur auf Grundlage
          des Angemessenheitsbeschlusses der EU-Kommission oder geeigneter
          Garantien wie den Standardvertragsklauseln.
        </p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          6. Ihre Rechte
        </h3>
        <p>
          Sie haben folgende Rechte in Bezug auf Ihre personenbezogenen Daten:
        </p>
        <ul className="list-disc list-inside">
          <li>
            Auskunftsrecht: Sie haben das Recht, eine Bestätigung darüber zu
            verlangen, ob personenbezogene Daten über Sie verarbeitet werden,
            und Informationen über diese Daten zu erhalten (Art. 15 DSGVO).
          </li>
          <li>
            Recht auf Berichtigung: Sie haben das Recht, unrichtige oder
            unvollständige Daten berichtigen zu lassen (Art. 16 DSGVO).
          </li>
          <li>
            Recht auf Löschung: Sie können die Löschung Ihrer personenbezogenen
            Daten verlangen, soweit keine gesetzlichen Aufbewahrungspflichten
            bestehen (Art. 17 DSGVO).
          </li>
          <li>
            Recht auf Einschränkung der Verarbeitung: Sie haben das Recht, die
            Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen (Art. 18 DSGVO).
          </li>
          <li>
            Recht auf Datenübertragbarkeit: Sie haben das Recht, Ihre
            personenbezogenen Daten in einem strukturierten, gängigen und
            maschinenlesbaren Format zu erhalten (Art. 20 DSGVO).
          </li>
          <li>
            Widerspruchsrecht: Sie haben das Recht, der Verarbeitung Ihrer
            personenbezogenen Daten zu widersprechen, wenn die Verarbeitung auf
            Art. 6 Abs. 1 lit. e oder f DSGVO beruht (Art. 21 DSGVO).
          </li>
        </ul>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          7. Speicherdauer
        </h3>
        <p>
          Wir speichern Ihre personenbezogenen Daten nur so lange, wie es für
          die Erfüllung der oben genannten Zwecke erforderlich ist oder wie es
          gesetzlich vorgeschrieben ist.
        </p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          8. Sicherheit
        </h3>
        <p>
          Wir setzen technische und organisatorische Maßnahmen ein, um Ihre
          Daten gegen Verlust, Zerstörung, Zugriff, Veränderung oder Verbreitung
          durch unbefugte Personen zu schützen.
        </p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          9. Änderungen der Datenschutzerklärung
        </h3>
        <p>
          Wir behalten uns das Recht vor, diese Datenschutzerklärung jederzeit
          zu ändern, um sie an geänderte Rechtsvorschriften oder neue
          Dienstleistungen anzupassen. Die aktuelle Version finden Sie stets auf
          unserer Webseite.
        </p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          10. Verwendung von KI-generierten Bildern
        </h3>
        <p>
          Auf unserer Webseite werden ausschließlich Bilder verwendet, die durch
          Künstliche Intelligenz (KI) erzeugt wurden. Diese Bilder stellen keine
          realen Personen, Orte oder Objekte dar und basieren nicht auf echten
          Bildvorlagen. Bei der Erstellung der KI-generierten Bilder werden
          keine personenbezogenen Daten verarbeitet oder verwendet. Sollten Sie
          Fragen zur Verwendung dieser Bilder haben, können Sie sich jederzeit
          an uns wenden.
        </p>

        <h3 className="text-sm md:text-xl font-semibold mt-6 mb-4">
          11. Kontakt
        </h3>
        <p>
          Bei Fragen zum Datenschutz oder zur Geltendmachung Ihrer Rechte wenden
          Sie sich bitte an uns unter:
        </p>
        <p>pauli@icehawkai.de</p>
      </div>
      <StyledButton
        onClick={handleBack}
        className="text-xs md:text-lg fixed top-4 right-4">
        Back
      </StyledButton>
    </div>
  );
};

export default Datenschutzerklaerung;
